module.exports = __webpack_public_path__ + "static/media/MHRP00N0001.127a31c9.svg";